import { Component, OnInit } from '@angular/core';
import { PurchaseOrderService } from '../../../service/vendor/purchase-order.service';
import { GrIrService } from '../../../service/gr-ir/gr-ir.service';
import { VendorTsService } from '../../../service/vendor/vendor.ts.service';
import { HomeService } from '../../../service/home-service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

interface FilterDate{
  startDate:any
  endDate:any
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements OnInit {
  //poChart
  poChartData: any;
  poOptions: any;

  //GR Chart
  grChartData:any;
  grOptions:any;


  //Schedule
  scheduleChartData: any;
  scheduleOptions: any;

  //Shipment
  shipmentChartData: any;
  shipmentOptions: any;

   //Ir
   irChartData: any;
   irOptions: any;

   //for all date
   startDate?:Date
   endDate?:Date


  //poCount
  openForScheduleCount: number = 0;
  openForDeliveryCount: number = 0;
  partialDeliveredCount: number = 0;
  deliveredCount: number = 0;
  poCount: number = 0;
  poStartDate?:Date
  poEndDate?:Date


  //grCount
  pendingForInvoiceCount:number =0;
  grCount: number = 0;
  invoicedCount: number = 0;
  grStartDate?:Date
  grEndDate?:Date

  //Shipment
  pendingForDeliveryCount:number =0;
  shipmentCount: number = 0;
  shipmentDeliveredCount: number = 0;
  shipmentStartDate?:Date
  shipmentEndDate?:Date

  //Ir
  openPaymentCount:number =0;
  partiallyPaidCount:number =0;
  irCount: number = 0;
  paidCount: number = 0;
  irStartDate?:Date
  irEndDate?:Date


  //scheduleCount
  scheduleCount: number = 0;
  shipmentPendingCount:number =0;
  shipmentCreatedCount:number =0;
  scheduleStartDate?:Date
  scheduleEndDate?:Date

  // schedulOpenForScheduleCount: number = 0;
  // schedulOpenForDeliveryCount: number = 0;
  // schedulPartialDeliveredCount: number = 0;
  // schedulDeliveredCount: number = 0;

  //deliverySchedule
  deliveryOpenCount: number = 0;
  deliveryDeliveredCount: number = 0;
  // shipmentCount: number = 0;

  //Pending Vendor
  pendingvendorCount:number = 0
  isVendorSuperAdmin=false
  vendorStatus="PENDING_ADMIN_APPROVAL"
  maxDateValue!: Date;
  maxDateValue1!: Date;
  minDateValue!: Date;


  constructor(
    private vendorService: VendorTsService,
    private homeService: HomeService,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {

    this.maxDateValue = new Date();
    this.maxDateValue1 = new Date();
    this.minDateValue = new Date();

    this.checkIfVendor()
    this.defaultFilterByDate()
    this.initializeChartData();
  }


  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  defaultFilterByDate(){
    //po
    this.poEndDate = new Date();
    this.poStartDate = new Date();
    this.poStartDate.setMonth(this.poStartDate.getMonth() - 1);

    //gr
    this.grStartDate=new Date()
    this.grEndDate = new Date();
    this.grStartDate.setMonth(this.grStartDate.getMonth() - 1);

    //shipment
    this.shipmentStartDate=new Date()
    this.shipmentEndDate = new Date();
    this.shipmentStartDate.setMonth(this.shipmentStartDate.getMonth() - 1);

    //schedule
    this.scheduleStartDate=new Date()
    this.scheduleEndDate = new Date();
    this.scheduleStartDate.setMonth(this.scheduleStartDate.getMonth() - 1);

    //ir
    this.irStartDate=new Date()
    this.irEndDate = new Date();
    this.irStartDate.setMonth(this.irStartDate.getMonth() - 1);

    //forAll
    this.startDate=new Date()
    this.endDate = new Date();
    this.startDate.setMonth(this.startDate.getMonth() - 1);
  }

   initializeChartData() {
    this.forAllFilterData()
    // this.poFilterDate();
    // this.grFilterDate();
    // this.scheduleFilterDate()
    // this.irFilterDate()
    // this.shipmentFilterDate()
    // this.grGetList();
    // this.irGetList();
    // this.poBarChart();
    // this.scheduleBarChart();
    // this.shipmentBarChart();
    this.pendingVendorList();
    // await this.poFilterDate();
  }

  checkIfVendor() {
    this.vendorService.checkIfVendor()
        .then((response) => {
          this.isVendorSuperAdmin=response.message.roles.includes("Vendor Super Admin") || response.message.roles.includes("Administrator")
        }).catch((error) => {
            console.log(error)
        });
}

  async POStatusCount() {


    // await this.purchaseOrderService
    //   .getPoList()
    //   .then((res) => {
    //     this.poCount = res.message.length;
    //     res.message.forEach((data: any) => {
    //       const status = data.po.status;
    //       const items = data.new_items;
    //       this.scheduleCount += data.new_items.length;
    //       switch (status) {
    //         case 'Open for Schedule':
    //           this.openForScheduleCount++;
    //           break;
    //         case 'Open for Delivery':
    //           this.openForDeliveryCount++;
    //           break;
    //         case 'Partial Delivered':
    //           this.partialDeliveredCount++;
    //           break;
    //         case 'Delivered':
    //           this.deliveredCount++;
    //           break;
    //         default:
    //           console.log('Unknown status:', status);
    //           break;
    //       }

    //       items.forEach((data: any) => {
    //         const itemStatus = data.item.status;
    //         const scheduleList = data.shipments;
    //         this.shipmentCount += scheduleList.length;
    //         switch (itemStatus) {
    //           case 'Open for Schedule':
    //             this.schedulOpenForScheduleCount++;
    //             break;
    //           case 'Open for Delivery':
    //             this.schedulOpenForDeliveryCount++;
    //             break;
    //           case 'Partial Delivered':
    //             this.schedulPartialDeliveredCount++;
    //             break;
    //           case 'Delivered':
    //             this.schedulDeliveredCount++;
    //             break;
    //           default:
    //             console.log('Unknown status:', status);
    //             break;
    //         }
    //         scheduleList.forEach((element: any) => {
    //           const deliverySchedule = element.delivery_schedule.status;
    //           switch (deliverySchedule) {
    //             case 'Open':
    //               this.deliveryOpenCount++;
    //               break;
    //             case 'Delivered':
    //               this.deliveryDeliveredCount++;
    //               break;
    //             default:
    //               console.log('Unknown status:', status);
    //               break;
    //           }
    //         });
    //       });
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  poFilterDate(){
    if (this.poStartDate != null && this.poEndDate != null) {
    this.openForScheduleCount  = 0;
    this.openForDeliveryCount = 0;
    this.partialDeliveredCount = 0;
    this.deliveredCount= 0;

    let date:FilterDate = {
      startDate:this.datePipe.transform(this.poStartDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.poEndDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.homeService.getPoByDate(date).then((res)=>{
      this.poCount = res.message.total_records;
      this.openForScheduleCount = res.message.openForScheduleCount;
      this.openForDeliveryCount = res.message.openForDeliveryCount;
      this.partialDeliveredCount = res.message.partialDeliveredCount;
      this.deliveredCount = res.message.deliveredCount;

    this.poDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })

  }

  }

  grFilterDate(){

    if (this.grStartDate != null && this.grEndDate != null) {

    this.pendingForInvoiceCount  = 0;
    this.invoicedCount = 0;

    let grdate:FilterDate = {
      startDate:this.datePipe.transform(this.grStartDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.grEndDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.homeService.getGrByDate(grdate).then((res)=>{
      this.grCount = res.message.total_records;
      this.pendingForInvoiceCount=res.message.pending_for_invoice_count
      this.invoicedCount=res.message.invoiced_count

    this.grDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })
  }
  }

  shipmentFilterDate(){
    if (this.shipmentStartDate != null && this.shipmentEndDate != null) {

    this.pendingForDeliveryCount  = 0;
    this.shipmentDeliveredCount = 0;

    let grdate:FilterDate = {
      startDate:this.datePipe.transform(this.shipmentStartDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.shipmentEndDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.homeService.getShipmentAsnByDate(grdate).then((res)=>{
      this.shipmentCount = res.message.total_records;
      this.pendingForDeliveryCount=res.message.pending_For_Delivery
      this.shipmentDeliveredCount=res.message.shipment_Delivered

    this.shipmentDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })
  }

  }

  scheduleFilterDate(){
    if (this.scheduleStartDate != null && this.scheduleEndDate != null) {

    this.shipmentPendingCount  = 0;
    this.shipmentCreatedCount = 0;

    let scheduledate:FilterDate = {
      startDate:this.datePipe.transform(this.scheduleStartDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.scheduleEndDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.homeService.getScheduleByDate(scheduledate).then((res)=>{
      this.scheduleCount = res.message.total_records;
      this.shipmentPendingCount=res.message.shipmentPendingCount
      this.shipmentCreatedCount=res.message.shipmentCreatedCount
    this.scheduleDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })
  }
  }

  irFilterDate(){
    if (this.irStartDate != null && this.irEndDate != null) {

    this.openPaymentCount  = 0;
    this.partiallyPaidCount = 0;
    this.paidCount = 0;


    let irdate:FilterDate = {
      startDate:this.datePipe.transform(this.irStartDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.irEndDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.homeService.getIrByDate(irdate).then((res)=>{
      this.irCount = res.message.total_records;
      this.openPaymentCount = res.message.open_payment;
      this.partiallyPaidCount = res.message.partially_paid;
      this.paidCount = res.message.paid;
    this.irDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })
  }
  }

  forAllFilterData(){
    if(this.startDate){
      this.minDateValue=this.startDate
    }
    if (this.endDate) {
      this.maxDateValue=this.endDate
    }
    if (this.startDate != null && this.endDate != null) {

    this.openPaymentCount  = 0;
    this.partiallyPaidCount = 0;
    this.paidCount = 0;
    this.shipmentPendingCount  = 0;
    this.shipmentCreatedCount = 0;
    this.pendingForDeliveryCount  = 0;
    this.shipmentDeliveredCount = 0;
    this.pendingForInvoiceCount  = 0;
    this.invoicedCount = 0;
    this.openForScheduleCount  = 0;
    this.openForDeliveryCount = 0;
    this.partialDeliveredCount = 0;
    this.deliveredCount= 0;

  // if (!this.startDate || !this.endDate) {

    let forAlldata:FilterDate = {
      startDate:this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.homeService.getPoByDate(forAlldata).then((res)=>{
      this.poCount = res.message.total_records;
      this.openForScheduleCount = res.message.openForScheduleCount;
      this.openForDeliveryCount = res.message.openForDeliveryCount;
      this.partialDeliveredCount = res.message.partialDeliveredCount;
      this.deliveredCount = res.message.deliveredCount;

    this.poDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })

    this.homeService.getGrByDate(forAlldata).then((res)=>{
      this.grCount = res.message.total_records;
      this.pendingForInvoiceCount=res.message.pending_for_invoice_count
      this.invoicedCount=res.message.invoiced_count
    this.grDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })

    this.homeService.getShipmentAsnByDate(forAlldata).then((res)=>{
      this.shipmentCount = res.message.total_records;
      this.pendingForDeliveryCount=res.message.pending_For_Delivery
      this.shipmentDeliveredCount=res.message.shipment_Delivered
      this.shipmentDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })

    this.homeService.getScheduleByDate(forAlldata).then((res)=>{
      this.scheduleCount = res.message.total_records;
      this.shipmentPendingCount=res.message.shipmentPendingCount
      this.shipmentCreatedCount=res.message.shipmentCreatedCount

    this.scheduleDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })

    this.homeService.getIrByDate(forAlldata).then((res)=>{
      this.irCount = res.message.total_records;
      this.openPaymentCount = res.message.open_payment;
      this.partiallyPaidCount = res.message.partially_paid;
      this.paidCount = res.message.paid;
    this.irDoughnutChart()
    }).catch((error)=>{
      console.log(error)
    })
  // }
    }


  }

  poDoughnutChart() {
    // const colors = {
    //   'Open for Schedule': 'rgba(0, 0, 255, 0.2)',
    //   'Open for Delivery': 'rgba(0, 123, 255, 0.2)',
    //   'Partial Delivered': 'rgba(40, 167, 69, 0.2)',
    //   'Delivered': 'rgba(220, 53, 69, 0.2)',
    // };
    // const borderColors = {
    //   'Open for Schedule': 'rgb(0, 0, 255)',
    //   'Open for Delivery': 'rgb(0, 123, 255)',
    //   'Partial Delivered': 'rgb(40, 167, 69)',
    //   'Delivered': 'rgb(220, 53, 69)',
    // };
    // const documentStyle = getComputedStyle(document.documentElement);
    // const textColor = documentStyle.getPropertyValue('--text-color');
    // const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    // const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    // this.po = {
    //   labels: ['Open Schedule', 'Open Delivery', 'Partial Delivered', 'Delivered'],
    //   datasets: [
    //     {
    //       label: 'Purchase Order',
          // backgroundColor: Object.values(colors),
          // borderColor: Object.values(borderColors),
    //       data: [
    //         this.openForScheduleCount,
    //         this.openForDeliveryCount,
    //         this.partialDeliveredCount,
    //         this.deliveredCount,
    //       ],
    //       borderWidth: 1,
    //       barThickness: 40,
    //     },
    //   ],
    // };

    // this.poOptions = {
    //   maintainAspectRatio: false,
    //   plugins: {
    //     legend: {
    //       labels: {
    //         color: textColor,
    //       },
    //     },
    //   },
    //   scales: {
    //     y: {
    //       beginAtZero: true,
    //       ticks: {
    //         color: textColorSecondary,
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false,
    //       },
    //     },
    //     x: {
    //       ticks: {
    //         color: textColorSecondary,
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false,
    //       },
    //     },
    //   },
    // };
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    const labels = [
      `Open for Schedule : ${this.openForScheduleCount}`,
      `Open for Delivery : ${this.openForDeliveryCount}`,
      `Partial Delivered : ${this.partialDeliveredCount}`,
      `Delivered : ${this.deliveredCount}`
    ];

    this.poChartData = {
        labels: labels,
        datasets: [
            {
                data: [this.openForScheduleCount,this.openForDeliveryCount , this.partialDeliveredCount,this.deliveredCount],
                backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--orange-500'),documentStyle.getPropertyValue('--yellow-500'),documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-200'), documentStyle.getPropertyValue('--orange-200'),documentStyle.getPropertyValue('--yellow-200'),documentStyle.getPropertyValue('--green-200')]
            }
        ]
    };

    this.poOptions = {
      cutout: '60%',
      responsive: false,
      plugins: {
          legend: {
              position: 'right',
              labels: {
                  color: textColor,
                  font: {
                      weight: 'bold',
                      size: 10 // Change the font size as desired
                  }
              }
          },
          tooltip: {
              enabled: false // Disable tooltips if not needed
          },
      }
  };
  }

  grDoughnutChart(){

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    const labels = [
      `Pending For Invoice : ${this.pendingForInvoiceCount}`,
      `Invoiced : ${this.invoicedCount}`
    ];

    this.grChartData = {
        labels: labels,
        datasets: [
            {
                data: [this.pendingForInvoiceCount,this.invoicedCount],
                backgroundColor: [documentStyle.getPropertyValue('--blue-500'),documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-200'),documentStyle.getPropertyValue('--green-200')]
            }
        ]
    };

    this.grOptions = {
      cutout: '60%',
      responsive: false,
      plugins: {
          legend: {
              position: 'right',
              labels: {
                  color: textColor,
                  font: {
                      weight: 'bold',
                      size: 10 // Change the font size as desired
                  }
              }
          },
          tooltip: {
              enabled: false // Disable tooltips if not needed
          },
      }
  };
  }

  shipmentDoughnutChart(){

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    const labels = [
      `Pending For Delivery : ${this.pendingForDeliveryCount}`,
      `Shipment Delivered : ${this.shipmentDeliveredCount}`
    ];

    this.shipmentChartData = {
        labels: labels,
        datasets: [
            {
                data: [this.pendingForDeliveryCount,this.shipmentDeliveredCount],
                backgroundColor: [documentStyle.getPropertyValue('--blue-500'),documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-200'),documentStyle.getPropertyValue('--green-200')]
            }
        ]
    };

    this.shipmentOptions = {
      cutout: '60%',
      responsive: false,
      plugins: {
          legend: {
              position: 'right',
              labels: {
                  color: textColor,
                  font: {
                      weight: 'bold',
                      size: 10 // Change the font size as desired
                  }
              }
          },
          tooltip: {
              enabled: false // Disable tooltips if not needed
          },
      }
  };

  }

  scheduleDoughnutChart(){

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    const labels = [
      `Shipment Pending : ${this.shipmentPendingCount}`,
      `Shipment Created : ${this.shipmentCreatedCount}`
    ];


    this.scheduleChartData = {
        labels: labels,
        datasets: [
            {
                data: [this.shipmentPendingCount,this.shipmentCreatedCount],
                backgroundColor: [documentStyle.getPropertyValue('--blue-500'),documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-200'),documentStyle.getPropertyValue('--green-200')]
            }
        ]
    };
    this.scheduleOptions = {
      cutout: '60%',
      responsive: false,
      plugins: {
          legend: {
              position: 'right',
              labels: {
                  color: textColor,
                  font: {
                      weight: 'bold',
                      size: 10 // Change the font size as desired
                  }
              }
          },
          tooltip: {
              enabled: false // Disable tooltips if not needed
          },
      }
  };

  }

  // irDoughnutChart(){

  //   const documentStyle = getComputedStyle(document.documentElement);
  //   const textColor = documentStyle.getPropertyValue('--text-color');

  //   this.irChartData = {
  //       labels: ['Open Payment', 'Partially Paid','Paid'],
  //       datasets: [
  //           {
  //               data: [this.openPaymentCount,this.partiallyPaidCount,this.paidCount],
  //               backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--yellow-500'),documentStyle.getPropertyValue('--green-500')],
  //               hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-50'), documentStyle.getPropertyValue('--yellow-50'),documentStyle.getPropertyValue('--green-50')]
  //           }
  //       ]
  //   };


  //   this.irOptions = {
  //       cutout: '60%',
  //       responsive:false,
  //       plugins: {
  //           legend: {
  //               labels: {
  //                   color: textColor
  //               }
  //           }
  //       }
  //   };
  // }

//   irDoughnutChart() {
//     const documentStyle = getComputedStyle(document.documentElement);
//     const textColor = documentStyle.getPropertyValue('--text-color');

//     this.irChartData = {
        // labels: ['Open Payment' + '  '+ this.openPaymentCount, 'Partially Paid' + '  ' + this.partiallyPaidCount, 'Paid' + '  ' + this.paidCount],
//         datasets: [
//             {
//                 data: [this.openPaymentCount, this.partiallyPaidCount, this.paidCount],
//                 backgroundColor: [
//                     documentStyle.getPropertyValue('--blue-500'),
//                     documentStyle.getPropertyValue('--yellow-500'),
//                     documentStyle.getPropertyValue('--green-500')
//                 ],
//                 hoverBackgroundColor: [
//                     documentStyle.getPropertyValue('--blue-50'),
//                     documentStyle.getPropertyValue('--yellow-50'),
//                     documentStyle.getPropertyValue('--green-50')
//                 ]
//             }
//         ]
//     };

//     this.irOptions = {
//         cutout: '60%',
//         responsive: false,
//         plugins: {
//             legend: {
//                 position: 'right',
//                 labels: {
//                     color: textColor
//                 }
//             },
//             tooltip: {
//                 enabled: false // Disable tooltips if not needed
//             },
//         }
//     };
// }

irDoughnutChart() {
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue('--text-color');

  // Initialize labels separately
  const labels = [
      `Open Payment : ${this.openPaymentCount}`,
      `Partially Paid : ${this.partiallyPaidCount}`,
      `Paid : ${this.paidCount}`
  ];

  this.irChartData = {
      labels: labels,
      datasets: [
          {
              data: [this.openPaymentCount, this.partiallyPaidCount, this.paidCount],
              backgroundColor: [
                  documentStyle.getPropertyValue('--blue-500'),
                  documentStyle.getPropertyValue('--yellow-500'),
                  documentStyle.getPropertyValue('--green-500')
              ],
              hoverBackgroundColor: [
                  documentStyle.getPropertyValue('--blue-200'),
                  documentStyle.getPropertyValue('--yellow-200'),
                  documentStyle.getPropertyValue('--green-200')
              ]
          }
      ]
  };

  this.irOptions = {
      cutout: '60%',
      responsive: false,
      plugins: {
          legend: {
              position: 'right',
              labels: {
                  color: textColor,
                  font: {
                      weight: 'bold',
                      size: 10 // Change the font size as desired
                  }
              }
          },
          tooltip: {
              enabled: false // Disable tooltips if not needed
          },
      }
  };
}



  scheduleBarChart() {
    // const colors = {
    //   'Open for Schedule': 'rgba(255, 165, 0, 0.2)',
    //   'Open for Delivery': 'rgba(0, 123, 255, 0.2)',
    //   'Partial Delivered': 'rgba(40, 167, 69, 0.2)',
    //   'Delivered': 'rgba(220, 53, 69, 0.2)',
    // };
    // const borderColors = {
    //   'Open for Schedule': 'rgb(255, 165, 0)',
    //   'Open for Delivery': 'rgb(0, 123, 255)',
    //   'Partial Delivered': 'rgb(40, 167, 69)',
    //   'Delivered': 'rgb(220, 53, 69)',
    // };
    // const documentStyle = getComputedStyle(document.documentElement);
    // const textColor = documentStyle.getPropertyValue('--text-color');
    // const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    // const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    // this.schedule = {
    //   labels: ['Open Schedule', 'Open Delivery', 'Partial Delivered', 'Delivered'],
    //   datasets: [
    //     {
    //       label: 'Schedule',
    //       backgroundColor: Object.values(colors),
    //       borderColor: Object.values(borderColors),
    //       data: [
    //         this.schedulOpenForScheduleCount,
    //         this.schedulOpenForDeliveryCount,
    //         this.schedulPartialDeliveredCount,
    //         this.schedulDeliveredCount,
    //       ],
    //       borderWidth: 1,
    //       barThickness: 40,
    //     },
    //   ],
    // };

    // this.scheduleOptions = {
    //   maintainAspectRatio: false,
    //   plugins: {
    //     legend: {
    //       labels: {
    //         color: textColor,
    //       },
    //     },
    //   },
    //   scales: {
    //     y: {
    //       beginAtZero: true,
    //       ticks: {
    //         color: textColorSecondary,
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false,
    //       },
    //     },
    //     x: {
    //       ticks: {
    //         color: textColorSecondary,
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false,
    //       },
    //     },
    //   },
    // };
  }

  shipmentBarChart() {
  //   const colors = {
  //     'Open': 'rgba(255, 165, 0, 0.2)',
  //     'Delivered': 'rgba(40, 167, 69, 0.2)',
  //   };
  //   const borderColors = {
  //     'Open': 'rgb(255, 165, 0)',
  //     'Delivered': 'rgb(40, 167, 69)',
  //   };
  //   const documentStyle = getComputedStyle(document.documentElement);
  //   const textColor = documentStyle.getPropertyValue('--text-color');
  //   const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
  //   const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

  //   this.shipment = {
  //     labels: ['Open', 'Delivered'],
  //     datasets: [
  //       {
  //         label: 'Shipment',
  //         backgroundColor: Object.values(colors),
  //         borderColor: Object.values(borderColors),
  //         data: [this.deliveryOpenCount, this.deliveryDeliveredCount],
  //         borderWidth: 1,
  //         barThickness: 50,
  //       },
  //     ],
  //   };

  //   this.shipmentOptions = {
  //     maintainAspectRatio: false,
  //     plugins: {
  //       legend: {
  //         labels: {
  //           color: textColor,
  //         },
  //       },
  //     },
  //     scales: {
  //       y: {
  //         beginAtZero: true,
  //         ticks: {
  //           color: textColorSecondary,
  //         },
  //         grid: {
  //           color: surfaceBorder,
  //           drawBorder: false,
  //         },
  //       },
  //       x: {
  //         ticks: {
  //           color: textColorSecondary,
  //         },
  //         grid: {
  //           color: surfaceBorder,
  //           drawBorder: false,
  //         },
  //       },
  //     },
  //   };
  }

  // grGetList() {
  //   this.grIrService
  //     .getGRList()
  //     .then((res) => {
  //       this.grCount = res.message.length;
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  // irGetList() {
  //   this.grIrService
  //     .getIRList()
  //     .then((res) => {
  //       this.irCount = res.message.length;
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  pendingVendorList(){
    this.vendorService.getVendorMasterList(this.vendorStatus).then((response)=>{
      this.pendingvendorCount=response.message.length
    }).catch((error)=>{
      console.log(error)
    })
  }
}
